// Arabic translations for the platform
export const translations = {
  // Common
  common: {
    loading: "جاري التحميل...",
    error: "خطأ",
    success: "نجح",
    warning: "تحذير",
    info: "معلومات",
    save: "حفظ",
    cancel: "إلغاء",
    delete: "حذف",
    edit: "تعديل",
    add: "إضافة",
    view: "عرض",
    search: "بحث",
    filter: "تصفية",
    sort: "ترتيب",
    next: "التالي",
    previous: "السابق",
    submit: "إرسال",
    close: "إغلاق",
    confirm: "تأكيد",
    yes: "نعم",
    no: "لا",
    select: "اختيار",
    upload: "رفع",
    download: "تحميل",
    refresh: "تحديث",
    back: "رجوع",
    home: "الرئيسية",
    dashboard: "لوحة التحكم",
    profile: "الملف الشخصي",
    settings: "الإعدادات",
    logout: "تسجيل الخروج",
    login: "تسجيل الدخول",
    register: "التسجيل",
    email: "البريد الإلكتروني",
    password: "كلمة المرور",
    username: "اسم المستخدم",
    name: "الاسم",
    phone: "رقم الهاتف",
    address: "العنوان",
    date: "التاريخ",
    time: "الوقت",
    status: "الحالة",
    active: "نشط",
    inactive: "غير نشط",
    enabled: "مفعل",
    disabled: "معطل",
    public: "عام",
    private: "خاص",
    draft: "مسودة",
    published: "منشور",
    pending: "في الانتظار",
    approved: "موافق عليه",
    rejected: "مرفوض",
    completed: "مكتمل",
    inProgress: "قيد التنفيذ",
    notStarted: "لم يبدأ",
    total: "المجموع",
    count: "العدد",
    percentage: "النسبة المئوية",
    average: "المتوسط",
    minimum: "الحد الأدنى",
    maximum: "الحد الأقصى"
  },

  // Navigation
  navigation: {
    home: "الرئيسية",
    courses: "الدورات",
    dashboard: "لوحة التحكم",
    profile: "الملف الشخصي",
    notifications: "الإشعارات",
    settings: "الإعدادات",
    help: "المساعدة",
    about: "حول المنصة",
    contact: "اتصل بنا",
    vision: "رؤيتنا",
    discover: "اكتشف المنصة",
    packs: "الباقات"
  },

  // Authentication
  auth: {
    login: "تسجيل الدخول",
    logout: "تسجيل الخروج",
    register: "إنشاء حساب",
    forgotPassword: "نسيت كلمة المرور؟",
    resetPassword: "إعادة تعيين كلمة المرور",
    changePassword: "تغيير كلمة المرور",
    currentPassword: "كلمة المرور الحالية",
    newPassword: "كلمة المرور الجديدة",
    confirmPassword: "تأكيد كلمة المرور",
    email: "البريد الإلكتروني",
    username: "اسم المستخدم",
    rememberMe: "تذكرني",
    loginSuccess: "تم تسجيل الدخول بنجاح",
    logoutSuccess: "تم تسجيل الخروج بنجاح",
    loginError: "خطأ في تسجيل الدخول",
    invalidCredentials: "البريد الإلكتروني أو كلمة المرور غير صحيحة",
    sessionExpired: "انتهت صلاحية الجلسة",
    passwordResetSent: "تم إرسال رابط إعادة تعيين كلمة المرور",
    passwordResetSuccess: "تم تغيير كلمة المرور بنجاح",
    accountCreated: "تم إنشاء الحساب بنجاح",
    emailRequired: "البريد الإلكتروني مطلوب",
    passwordRequired: "كلمة المرور مطلوبة",
    usernameRequired: "اسم المستخدم مطلوب",
    passwordTooShort: "كلمة المرور قصيرة جداً",
    passwordsDoNotMatch: "كلمات المرور غير متطابقة",
    invalidEmail: "البريد الإلكتروني غير صحيح"
  },

  // Roles
  roles: {
    admin: "مدير",
    instructor: "مدرس",
    student: "طالب",
    user: "مستخدم"
  },

  // Dashboard
  dashboard: {
    welcome: "مرحباً بك",
    overview: "نظرة عامة",
    statistics: "الإحصائيات",
    recentActivity: "النشاط الحديث",
    quickActions: "الإجراءات السريعة",
    
    // Admin Dashboard
    admin: {
      title: "لوحة تحكم المدير",
      subtitle: "مرحباً بك في لوحة تحكم المنصة",
      totalUsers: "إجمالي المستخدمين",
      totalStudents: "الطلاب",
      totalInstructors: "المدرسين",
      totalCourses: "الدورات",
      totalEnrollments: "إجمالي التسجيلات",
      completedCourses: "الدورات المكتملة",
      completionRate: "معدل الإكمال",
      pendingReclamations: "الشكاوى المعلقة",
      pendingFeedback: "التقييمات المعلقة",
      createUser: "إضافة مستخدم",
      createCourse: "إنشاء دورة",
      manageContent: "إدارة المحتوى",
      viewStatistics: "الإحصائيات",
      recentUsers: "المستخدمون الجدد",
      recentEnrollments: "التسجيلات الحديثة"
    },

    // Instructor Dashboard
    instructor: {
      title: "لوحة تحكم المدرس",
      subtitle: "إدارة دوراتك وطلابك",
      myCourses: "دوراتي",
      totalStudents: "إجمالي الطلاب",
      uploadedFiles: "الملفات المرفوعة",
      pendingComments: "التعليقات المعلقة",
      manageCourses: "إدارة الدورات",
      createQCM: "إنشاء اختبار",
      reviewFiles: "مراجعة الملفات",
      replyComments: "الرد على التعليقات",
      courseStatistics: "إحصائيات الدورات",
      studentsEnrolled: "طالب مسجل",
      completionRate: "معدل الإكمال",
      averageProgress: "متوسط التقدم",
      recentStudentActivity: "النشاط الحديث للطلاب",
      lastActivity: "آخر نشاط",
      quickStats: "إحصائيات سريعة",
      weeklyActiveStudents: "الطلاب النشطون هذا الأسبوع",
      averageWatchTime: "متوسط وقت المشاهدة",
      completedQCMs: "الاختبارات المكتملة",
      qcmSuccessRate: "معدل نجاح الاختبارات"
    },

    // Student Dashboard
    student: {
      title: "لوحة تحكم الطالب",
      subtitle: "مرحباً بك، تابع تقدمك في التعلم",
      enrolledCourses: "الدورات المسجلة",
      watchingHours: "ساعات المشاهدة",
      completedQCMs: "الاختبارات المكتملة",
      notifications: "الإشعارات",
      myCourses: "دوراتي",
      qcms: "الاختبارات",
      myFiles: "ملفاتي",
      recentNotifications: "الإشعارات الحديثة",
      upcomingQCMs: "الاختبارات القادمة",
      watchTime: "وقت المشاهدة",
      lastAccess: "آخر وصول",
      notAccessedYet: "لم يتم الوصول بعد",
      totalHours: "ساعة إجمالية",
      passed: "ناجح",
      unread: "غير مقروءة",
      viewAll: "عرض الكل",
      availableQCMs: "الاختبارات المتاحة",
      uploadedFiles: "الملفات المرفوعة",
      latestUpdates: "آخر التحديثات",
      start: "ابدأ",
      completed: "مكتملة",
      minutes: "دقيقة"
    }
  },

  // Courses
  courses: {
    title: "الدورات",
    myCourses: "دوراتي",
    allCourses: "جميع الدورات",
    enrolledCourses: "الدورات المسجلة",
    availableCourses: "الدورات المتاحة",
    courseDetails: "تفاصيل الدورة",
    enroll: "التسجيل",
    enrolled: "مسجل",
    completed: "مكتملة",
    inProgress: "قيد التقدم",
    notStarted: "لم تبدأ",
    instructor: "المدرس",
    duration: "المدة",
    lessons: "الدروس",
    students: "الطلاب",
    description: "الوصف",
    requirements: "المتطلبات",
    objectives: "الأهداف",
    curriculum: "المنهج",
    reviews: "التقييمات",
    rating: "التقييم",
    price: "السعر",
    free: "مجاني",
    premium: "مدفوع",
    beginner: "مبتدئ",
    intermediate: "متوسط",
    advanced: "متقدم",
    category: "الفئة",
    tags: "العلامات",
    language: "اللغة",
    arabic: "العربية",
    english: "الإنجليزية",
    french: "الفرنسية",
    createdAt: "تاريخ الإنشاء",
    updatedAt: "تاريخ التحديث",
    publishedAt: "تاريخ النشر",
    enrollmentCount: "عدد المسجلين",
    completionRate: "معدل الإكمال",
    averageRating: "متوسط التقييم",
    totalHours: "إجمالي الساعات",
    certificate: "شهادة",
    certificateAvailable: "شهادة متاحة",
    noCertificate: "لا توجد شهادة"
  },

  // QCM (Quiz/Test)
  qcm: {
    title: "الاختبارات",
    myQCMs: "اختباراتي",
    availableQCMs: "الاختبارات المتاحة",
    completedQCMs: "الاختبارات المكتملة",
    upcomingQCMs: "الاختبارات القادمة",
    qcmDetails: "تفاصيل الاختبار",
    takeQCM: "بدء الاختبار",
    retakeQCM: "إعادة الاختبار",
    qcmResult: "نتيجة الاختبار",
    qcmResults: "نتائج الاختبارات",
    questions: "الأسئلة",
    question: "السؤال",
    answer: "الإجابة",
    answers: "الإجابات",
    correctAnswer: "الإجابة الصحيحة",
    yourAnswer: "إجابتك",
    score: "النتيجة",
    totalScore: "النتيجة الإجمالية",
    passingScore: "درجة النجاح",
    passed: "ناجح",
    failed: "راسب",
    timeLimit: "الوقت المحدد",
    timeRemaining: "الوقت المتبقي",
    timeSpent: "الوقت المستغرق",
    attempts: "المحاولات",
    attempt: "محاولة",
    maxAttempts: "الحد الأقصى للمحاولات",
    allowRetake: "السماح بالإعادة",
    showResults: "عرض النتائج",
    showCorrectAnswers: "عرض الإجابات الصحيحة",
    randomizeQuestions: "ترتيب عشوائي للأسئلة",
    randomizeAnswers: "ترتيب عشوائي للإجابات",
    multipleChoice: "اختيار متعدد",
    trueFalse: "صح أو خطأ",
    shortAnswer: "إجابة قصيرة",
    essay: "مقال",
    instructions: "التعليمات",
    startQCM: "بدء الاختبار",
    submitQCM: "إرسال الاختبار",
    saveAndContinue: "حفظ والمتابعة",
    previousQuestion: "السؤال السابق",
    nextQuestion: "السؤال التالي",
    questionNumber: "السؤال رقم",
    of: "من",
    congratulations: "تهانينا!",
    qcmCompleted: "تم إكمال الاختبار",
    qcmSubmitted: "تم إرسال الاختبار",
    qcmNotSubmitted: "لم يتم إرسال الاختبار",
    qcmExpired: "انتهت صلاحية الاختبار",
    qcmNotAvailable: "الاختبار غير متاح",
    qcmAlreadyTaken: "تم أخذ الاختبار مسبقاً",
    qcmNotStarted: "لم يبدأ الاختبار",
    qcmInProgress: "الاختبار قيد التنفيذ",
    qcmCompleted: "تم إكمال الاختبار",
    qcmGraded: "تم تقييم الاختبار",
    qcmNotGraded: "لم يتم تقييم الاختبار",
    autoGraded: "تقييم تلقائي",
    manualGrading: "تقييم يدوي",
    gradingInProgress: "التقييم قيد التنفيذ",
    feedback: "التعليق",
    explanation: "الشرح",
    hint: "تلميح",
    difficulty: "الصعوبة",
    easy: "سهل",
    medium: "متوسط",
    hard: "صعب",
    points: "النقاط",
    totalPoints: "إجمالي النقاط",
    earnedPoints: "النقاط المكتسبة",
    percentage: "النسبة المئوية",
    grade: "الدرجة",
    letterGrade: "الدرجة الحرفية",
    gpa: "المعدل التراكمي"
  },

  // Notifications
  notifications: {
    title: "الإشعارات",
    allNotifications: "جميع الإشعارات",
    unreadNotifications: "الإشعارات غير المقروءة",
    readNotifications: "الإشعارات المقروءة",
    markAsRead: "تحديد كمقروء",
    markAsUnread: "تحديد كغير مقروء",
    markAllAsRead: "تحديد الكل كمقروء",
    deleteNotification: "حذف الإشعار",
    deleteAllRead: "حذف جميع المقروءة",
    noNotifications: "لا توجد إشعارات",
    newNotification: "إشعار جديد",
    notificationSettings: "إعدادات الإشعارات",
    emailNotifications: "إشعارات البريد الإلكتروني",
    pushNotifications: "الإشعارات المنبثقة",
    smsNotifications: "إشعارات الرسائل النصية",
    courseNotifications: "إشعارات الدورات",
    qcmNotifications: "إشعارات الاختبارات",
    systemNotifications: "إشعارات النظام",
    priority: {
      low: "منخفضة",
      medium: "متوسطة",
      high: "عالية",
      urgent: "عاجلة"
    },
    types: {
      courseEnrollment: "تسجيل في دورة",
      courseUpdate: "تحديث الدورة",
      qcmAvailable: "اختبار متاح",
      qcmResult: "نتيجة الاختبار",
      commentReply: "رد على التعليق",
      uploadFeedback: "تقييم الملف",
      reclamationUpdate: "تحديث الشكوى",
      feedbackResponse: "رد على التقييم",
      systemAnnouncement: "إعلان النظام",
      instructorMessage: "رسالة من المدرس",
      adminMessage: "رسالة من المدير"
    }
  },

  // Profile
  profile: {
    title: "الملف الشخصي",
    editProfile: "تعديل الملف الشخصي",
    personalInfo: "المعلومات الشخصية",
    accountSettings: "إعدادات الحساب",
    securitySettings: "إعدادات الأمان",
    privacySettings: "إعدادات الخصوصية",
    firstName: "الاسم الأول",
    lastName: "الاسم الأخير",
    fullName: "الاسم الكامل",
    dateOfBirth: "تاريخ الميلاد",
    gender: "الجنس",
    male: "ذكر",
    female: "أنثى",
    phoneNumber: "رقم الهاتف",
    parentPhoneNumber: "رقم هاتف ولي الأمر",
    address: "العنوان",
    city: "المدينة",
    country: "البلد",
    bio: "نبذة شخصية",
    avatar: "الصورة الشخصية",
    uploadAvatar: "رفع صورة شخصية",
    changeAvatar: "تغيير الصورة الشخصية",
    removeAvatar: "إزالة الصورة الشخصية",
    socialLinks: "الروابط الاجتماعية",
    website: "الموقع الإلكتروني",
    facebook: "فيسبوك",
    twitter: "تويتر",
    linkedin: "لينكد إن",
    instagram: "إنستغرام",
    youtube: "يوتيوب",
    github: "جيت هاب",
    profileUpdated: "تم تحديث الملف الشخصي",
    profileUpdateError: "خطأ في تحديث الملف الشخصي",
    deleteAccount: "حذف الحساب",
    deleteAccountConfirmation: "هل أنت متأكد من حذف حسابك؟",
    accountDeleted: "تم حذف الحساب",
    accountDeletionError: "خطأ في حذف الحساب"
  },

  // Files and Uploads
  files: {
    title: "الملفات",
    myFiles: "ملفاتي",
    uploadFile: "رفع ملف",
    uploadFiles: "رفع ملفات",
    downloadFile: "تحميل الملف",
    deleteFile: "حذف الملف",
    fileName: "اسم الملف",
    fileSize: "حجم الملف",
    fileType: "نوع الملف",
    uploadDate: "تاريخ الرفع",
    uploadedBy: "رفع بواسطة",
    fileDescription: "وصف الملف",
    fileNotes: "ملاحظات الملف",
    allowedFileTypes: "أنواع الملفات المسموحة",
    maxFileSize: "الحد الأقصى لحجم الملف",
    dragAndDrop: "اسحب وأفلت الملفات هنا",
    browseFiles: "تصفح الملفات",
    selectFiles: "اختيار الملفات",
    uploadProgress: "تقدم الرفع",
    uploadComplete: "تم الرفع بنجاح",
    uploadFailed: "فشل في الرفع",
    fileUploaded: "تم رفع الملف",
    fileDeleted: "تم حذف الملف",
    fileNotFound: "الملف غير موجود",
    fileTooBig: "الملف كبير جداً",
    fileTypeNotAllowed: "نوع الملف غير مسموح",
    noFilesUploaded: "لم يتم رفع أي ملفات",
    totalFiles: "إجمالي الملفات",
    totalSize: "الحجم الإجمالي",
    recentUploads: "الملفات المرفوعة حديثاً"
  },

  // Comments
  comments: {
    title: "التعليقات",
    addComment: "إضافة تعليق",
    editComment: "تعديل التعليق",
    deleteComment: "حذف التعليق",
    replyToComment: "الرد على التعليق",
    comment: "تعليق",
    reply: "رد",
    replies: "الردود",
    showReplies: "عرض الردود",
    hideReplies: "إخفاء الردود",
    commentAdded: "تم إضافة التعليق",
    commentUpdated: "تم تحديث التعليق",
    commentDeleted: "تم حذف التعليق",
    replyAdded: "تم إضافة الرد",
    noComments: "لا توجد تعليقات",
    writeComment: "اكتب تعليقاً...",
    writeReply: "اكتب رداً...",
    commentTooShort: "التعليق قصير جداً",
    commentTooLong: "التعليق طويل جداً",
    commentRequired: "التعليق مطلوب",
    pendingApproval: "في انتظار الموافقة",
    approved: "موافق عليه",
    rejected: "مرفوض",
    hidden: "مخفي",
    public: "عام",
    private: "خاص",
    instructorOnly: "للمدرس فقط"
  },

  // Reclamations/Complaints
  reclamations: {
    title: "الشكاوى",
    myReclamations: "شكاواي",
    submitReclamation: "تقديم شكوى",
    reclamationDetails: "تفاصيل الشكوى",
    reclamationType: "نوع الشكوى",
    reclamationSubject: "موضوع الشكوى",
    reclamationDescription: "وصف الشكوى",
    reclamationStatus: "حالة الشكوى",
    reclamationPriority: "أولوية الشكوى",
    reclamationCategory: "فئة الشكوى",
    attachments: "المرفقات",
    submitDate: "تاريخ التقديم",
    lastUpdate: "آخر تحديث",
    assignedTo: "مُعين إلى",
    resolution: "الحل",
    resolutionDate: "تاريخ الحل",
    feedback: "التعليق",
    rating: "التقييم",
    followUp: "المتابعة",
    escalate: "تصعيد",
    close: "إغلاق",
    reopen: "إعادة فتح",
    status: {
      pending: "في الانتظار",
      inProgress: "قيد المراجعة",
      resolved: "تم الحل",
      closed: "مغلقة",
      rejected: "مرفوضة",
      escalated: "مُصعدة"
    },
    priority: {
      low: "منخفضة",
      medium: "متوسطة",
      high: "عالية",
      urgent: "عاجلة"
    },
    category: {
      technical: "تقنية",
      content: "المحتوى",
      billing: "الفواتير",
      account: "الحساب",
      general: "عامة",
      other: "أخرى"
    },
    reclamationSubmitted: "تم تقديم الشكوى",
    reclamationUpdated: "تم تحديث الشكوى",
    reclamationClosed: "تم إغلاق الشكوى",
    noReclamations: "لا توجد شكاوى",
    reclamationRequired: "الشكوى مطلوبة",
    subjectRequired: "الموضوع مطلوب",
    descriptionRequired: "الوصف مطلوب"
  },

  // Feedback
  feedback: {
    title: "التقييمات",
    submitFeedback: "تقديم تقييم",
    myFeedback: "تقييماتي",
    feedbackDetails: "تفاصيل التقييم",
    feedbackType: "نوع التقييم",
    feedbackSubject: "موضوع التقييم",
    feedbackMessage: "رسالة التقييم",
    rating: "التقييم",
    rateExperience: "قيم تجربتك",
    excellent: "ممتاز",
    good: "جيد",
    average: "متوسط",
    poor: "ضعيف",
    terrible: "سيء جداً",
    anonymous: "مجهول",
    publicFeedback: "تقييم عام",
    privateFeedback: "تقييم خاص",
    feedbackSubmitted: "تم تقديم التقييم",
    feedbackUpdated: "تم تحديث التقييم",
    feedbackDeleted: "تم حذف التقييم",
    noFeedback: "لا توجد تقييمات",
    feedbackRequired: "التقييم مطلوب",
    ratingRequired: "التقييم مطلوب",
    thankYou: "شكراً لك على تقييمك",
    feedbackHelps: "تقييمك يساعدنا على التحسين"
  },

  // Statistics
  statistics: {
    title: "الإحصائيات",
    overview: "نظرة عامة",
    detailed: "تفصيلية",
    summary: "ملخص",
    trends: "الاتجاهات",
    comparison: "المقارنة",
    analytics: "التحليلات",
    reports: "التقارير",
    charts: "الرسوم البيانية",
    graphs: "الرسوم البيانية",
    tables: "الجداول",
    export: "تصدير",
    print: "طباعة",
    share: "مشاركة",
    period: "الفترة",
    daily: "يومي",
    weekly: "أسبوعي",
    monthly: "شهري",
    yearly: "سنوي",
    custom: "مخصص",
    from: "من",
    to: "إلى",
    total: "المجموع",
    average: "المتوسط",
    minimum: "الحد الأدنى",
    maximum: "الحد الأقصى",
    growth: "النمو",
    decline: "الانخفاض",
    increase: "الزيادة",
    decrease: "النقصان",
    percentage: "النسبة المئوية",
    count: "العدد",
    rate: "المعدل",
    ratio: "النسبة",
    distribution: "التوزيع",
    breakdown: "التفصيل",
    category: "الفئة",
    segment: "الشريحة",
    metric: "المقياس",
    kpi: "مؤشر الأداء الرئيسي",
    benchmark: "المعيار",
    target: "الهدف",
    actual: "الفعلي",
    forecast: "التوقع",
    projection: "الإسقاط"
  },

  // Time and Date
  time: {
    now: "الآن",
    today: "اليوم",
    yesterday: "أمس",
    tomorrow: "غداً",
    thisWeek: "هذا الأسبوع",
    lastWeek: "الأسبوع الماضي",
    nextWeek: "الأسبوع القادم",
    thisMonth: "هذا الشهر",
    lastMonth: "الشهر الماضي",
    nextMonth: "الشهر القادم",
    thisYear: "هذا العام",
    lastYear: "العام الماضي",
    nextYear: "العام القادم",
    seconds: "ثواني",
    minutes: "دقائق",
    hours: "ساعات",
    days: "أيام",
    weeks: "أسابيع",
    months: "أشهر",
    years: "سنوات",
    second: "ثانية",
    minute: "دقيقة",
    hour: "ساعة",
    day: "يوم",
    week: "أسبوع",
    month: "شهر",
    year: "سنة",
    ago: "منذ",
    in: "خلال",
    at: "في",
    on: "في",
    duration: "المدة",
    elapsed: "المنقضي",
    remaining: "المتبقي",
    deadline: "الموعد النهائي",
    schedule: "الجدولة",
    timezone: "المنطقة الزمنية"
  },

  // Messages and Alerts
  messages: {
    success: "تم بنجاح",
    error: "حدث خطأ",
    warning: "تحذير",
    info: "معلومات",
    confirmation: "تأكيد",
    loading: "جاري التحميل...",
    saving: "جاري الحفظ...",
    deleting: "جاري الحذف...",
    uploading: "جاري الرفع...",
    downloading: "جاري التحميل...",
    processing: "جاري المعالجة...",
    connecting: "جاري الاتصال...",
    disconnected: "منقطع الاتصال",
    reconnecting: "جاري إعادة الاتصال...",
    connected: "متصل",
    offline: "غير متصل",
    online: "متصل",
    networkError: "خطأ في الشبكة",
    serverError: "خطأ في الخادم",
    notFound: "غير موجود",
    unauthorized: "غير مخول",
    forbidden: "ممنوع",
    timeout: "انتهت المهلة الزمنية",
    cancelled: "تم الإلغاء",
    completed: "تم الإكمال",
    failed: "فشل",
    retry: "إعادة المحاولة",
    tryAgain: "حاول مرة أخرى",
    contactSupport: "اتصل بالدعم",
    reportProblem: "الإبلاغ عن مشكلة",
    somethingWentWrong: "حدث خطأ ما",
    pleaseTryAgain: "يرجى المحاولة مرة أخرى",
    noDataAvailable: "لا توجد بيانات متاحة",
    noResultsFound: "لم يتم العثور على نتائج",
    searchNoResults: "لم يتم العثور على نتائج للبحث",
    emptyState: "لا توجد عناصر",
    comingSoon: "قريباً",
    underMaintenance: "تحت الصيانة",
    temporarilyUnavailable: "غير متاح مؤقتاً"
  }
};

// Helper function to get nested translation
export const t = (key, fallback = key) => {
  const keys = key.split('.');
  let value = translations;
  
  for (const k of keys) {
    if (value && typeof value === 'object' && k in value) {
      value = value[k];
    } else {
      return fallback;
    }
  }
  
  return typeof value === 'string' ? value : fallback;
};

// Helper function for pluralization (Arabic has complex plural rules)
export const tp = (key, count, fallback = key) => {
  const translation = t(key, fallback);
  
  // Arabic pluralization rules (simplified)
  if (count === 0) return `لا ${translation}`;
  if (count === 1) return translation;
  if (count === 2) return `${translation}ان`;
  if (count >= 3 && count <= 10) return `${count} ${translation}`;
  return `${count} ${translation}`;
};

export default translations;

